/**
 * The automated move flow (Asana 1219524311157587): the AI voice agent's
 * pre-move confirmation and post-move check-in calls. Each job carries the
 * latest finished call of each kind (job.aiCalls: [{type, outcome, sentiment,
 * successful, attention, summary, endedAt}]) so the MC sees that it ran.
 */

const KIND = { pre_move: "AI confirmation call", post_move: "AI post-move call" };

export const aiCallFor = (job, type) => ((job && job.aiCalls) || []).find((c) => c.type === type) || null;

/**
 * {cls, label} for a call: "open" (red) when the AI monitor flagged it and it is
 * not resolved, or the client was unhappy; "resolved" (green) when it reached
 * the client and went well; "plain" when nobody answered.
 */
export const aiCallTag = (call) => {
  if (!call) return null;
  const kind = KIND[call.type] || "AI call";
  if (call.outcome === "voicemail") return { cls: "plain", label: `${kind}: voicemail` };
  if (call.outcome === "no_answer" || call.outcome === "failed") return { cls: "plain", label: `${kind}: no answer` };
  if (call.attention || call.sentiment === "negative") return { cls: "open", label: `${kind}: needs follow-up` };
  if (call.sentiment === "positive") return { cls: "resolved", label: `${kind}: done · positive` };
  return { cls: "resolved", label: `${kind}: done` };
};

/** The card shows the post-move call once there is one, else the confirmation call. */
export const cardAiCall = (job) => aiCallFor(job, "post_move") || aiCallFor(job, "pre_move");
